import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('approveEmployeeDeeds') || initialState;

export const selectError = createSelector(selectState, (state) => state.get('error'));
